module.exports = __webpack_public_path__ + "static/media/emptyBlank.54bb8c67.svg";